import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { FC, useCallback, useState } from "react";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { Input } from "../../../lib/src/components/form/Input";
import { PillSelect } from "../../../lib/src/components/form/PillSelect";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";
import { usePermissions } from "../../../lib/src/auth/permissions";

export const AddMailAliasOrForwardModal: FC<{ domain: MailDomain }> = ({ domain }) => {
  const { partnerClient } = useApiClient(config)
  const { can } = usePermissions(partnerClient)
  // Adding an alias needs edit, adding a forward needs create.
  const options: Record<string, string> = {
    ...(can('edit', 'mail') ? { alias: 'Alias' } : {}),
    ...(can('create', 'mail') ? { forward: 'Forward' } : {}),
  }
  const [filter, setFilter] = useState<string>(Object.keys(options)[0] ?? 'alias')

  const reload = useRefresh()
  const [email, setEmail] = useState('')
  const [alias, setAlias] = useState('')
  const [forward, setForward] = useState('')
  const [error, setError] = useState('')
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!

  //Alias
  const saveAlias = useCallback(async () => {
    const deployment = await partnerClient.addAliasToMailDomain(domain.id, `${email}@${domain.displayName}`, alias).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
      return result.data
    })
    if (deployment.entityId) {
      await awaitNextDeploymentFinished(deployment.entityId)
    }
    reload()
  }, [domain, email, alias])

  //Forward
  const saveForward = useCallback(async () => {
    const deployment = await partnerClient.addForwardToMailDomain(domain.id, `${email}@${domain.displayName}`, forward).then(result => {
      console.log(`${email}@${domain.displayName}`)
      console.log(forward)
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
      return result.data
    })
    if (deployment.entityId) {
      await awaitNextDeploymentFinished(deployment.entityId)
    }
    reload()
  }, [domain, email, forward])

  return <>
    <div>
      <PillSelect value={filter} onChange={setFilter} options={options} />
      <p className={"text-slate-500 text-sm my-3"}>
        {filter === 'alias' ?
          "Start address may be an external address, but target needs to be within the user list" :
          "The start address needs to be in the user list. The target can be an extern address"}
      </p>
    </div>
    <form onSubmit={() => filter === 'alias' ? saveAlias() : saveForward()} className={"space-y-4 flex-1"}>
      <div className={"flex items-end max-w-md space-x-4"}>
        <Input label={'Start address'} type={"text"} value={filter === 'alias' ? alias : email} onChange={filter === 'alias' ? setAlias : setEmail} />
        {filter === 'alias' ? '' : <div className={"h-10 flex items-center font-medium text-slate-800 ml-2"}>@{domain.displayName}</div>}
      </div>
      <div className={"flex items-end max-w-md space-x-4"}>
        <Input label={'Target address'} type={"text"} value={filter === 'alias' ? email : forward} onChange={filter === 'alias' ? setEmail : setForward} />
        {filter === 'alias' ? <div className={"h-10 flex items-center font-medium text-slate-800 ml-2"}>@{domain.displayName}</div> : ''}
      </div>
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
    </form>
    <ModalFooter text={"Save"} onSubmit={filter === 'alias' ? saveAlias : saveForward} />
  </>
}
